































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class YesNoComponent extends Vue {
  @Prop({ default: 'Is this Page useful?' }) readonly legend!: string;
  @Prop({ default: false }) readonly showText!: boolean;
  @Prop({ default: true }) readonly showRating!: boolean;
  @Prop({ default: false }) readonly showAnonymous!: boolean;
  @Prop({ default: false }) readonly isAnonymous!: boolean;
  @Prop({ default: null }) readonly callback!: YesNoCallback;
  @Prop({ default: 'orange' }) readonly backgroundColor!: string;

  private yesNoText = '';
  private rules = {
    length: (len:number) => (v:string) => (v || '').length <= len || `Feedback text must be less than ${len} chars`,
  };
  private isAddingYesNo = false;
  private rating: number | null = null;
  private done = false;
  private myIsAnonymous = true;

  private mounted() {
    this.myIsAnonymous = this.isAnonymous;
    if(this.showRating)
      this.rating = 2.5;
  }

  private myYesNo(event: MouseEvent, yesno: boolean) {
    event.stopPropagation();
    this.isAddingYesNo = true;

    if(this.callback != null) {
      this.callback(event, yesno, this.yesNoText, this.rating, this.myIsAnonymous);
      this.done = true;
    }
    else
      console.error('No yes/no callback found: should define what to do on Yes or No.');

    this.isAddingYesNo = false;
  }
}
export interface YesNoCallback {
  (event: MouseEvent, yesno: boolean, text: string, rating: number|null, isAnonymous: boolean): void
}

Vue.component('yes-no-component', YesNoComponent);
